import { template as template_2788babb991e4ba5bdc09be61a8deeac } from "@ember/template-compiler";
import PendingInsuranceInfoBanner from './pending-insurance-info-banner';
import RejectedRequests from './rejected-requests';
import styles from './submission-notifications.module.scss';
export default template_2788babb991e4ba5bdc09be61a8deeac(`
  <div class={{styles.component}}>
    {{#if @pendingInsuranceRequests}}
      <PendingInsuranceInfoBanner @pendingInsuranceInfoCount={{@pendingInsuranceRequests.length}} />
    {{/if}}
    {{#if @rejectedInsuranceRequests}}
      <RejectedRequests @rejectedInsuranceRequests={{@rejectedInsuranceRequests}} />
    {{/if}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
